import styled from "styled-components";
import { Menu as BaseMenu } from "antd";

import color from "../_style/color";

const Menu = styled(BaseMenu)`
  padding: 0px;

  li {
    font-size: 14px;
    color: ${color.highempahis};
  }

  li:hover {
    background: ${color.whisper};
    color: ${color.primary};
    cursor: pointer;
  }
`;

export default Menu;
